var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00830078H513V341.992H0V-0.00830078Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342 -0.00830078H513V341.992H342V-0.00830078Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00830078H171V341.992H0V-0.00830078Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.2 129.092H239.4L256 79.2915L272.6 129.092H305.8V228.691L256 261.992L206.2 228.792V129.092ZM239.4 162.391V212.191H272.6V162.391H239.4Z",
    fill: "#AF7F59"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00830078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMd);
export default __webpack_public_path__ + "static/media/MD.42ac821fb495fc8e82625ba22c5f293a.svg";
export { ForwardRef as ReactComponent };